import { sum } from 'es-toolkit';
import React, { useState } from 'react';
import WarehouseIcon from '@mui/icons-material/Warehouse';

import { MenuAnchor } from '@paragon/client-tools';
import { AssemblyGroup } from '@paragon/contract-library';

import { ASSEMBLY_GROUPS_URL_SLUG } from '../../url-slugs';
import { AssemblyGroupMenu } from '../menus/AssemblyGroupMenu';
import { BaseCard } from './BaseCard';

export function AssemblyGroupCard(props: { readonly assemblyGroup: AssemblyGroup }) {
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  const quantities = Object.values(props.assemblyGroup.componentDesigns).map((cd) => cd.quantity ?? 1);
  const showTotal = quantities.every((q) => q !== undefined);
  const totalComponents = sum(quantities);

  return (
    <BaseCard
      avatar={<WarehouseIcon />}
      title={props.assemblyGroup.name}
      subheader={`${Object.keys(props.assemblyGroup.componentDesigns).length} Component Designs${showTotal ? ` (total: ${totalComponents})` : ''}`}
      linkTo={`/${ASSEMBLY_GROUPS_URL_SLUG}/${props.assemblyGroup.guid}`}
      menu={
        <AssemblyGroupMenu
          assemblyGroup={props.assemblyGroup}
          anchor={menuAnchor}
          onClose={() => setMenuAnchor(null)}
        />
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
